export default {"src":"/_next/static/media/directionSign_40.1f39f55d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};